import { mobileApiRequest } from '../../apiRequests'

// Investigation GROUP runs — the one real run method (the 7-stage pipeline the
// CLI runs for EZCorp districts). These wrap the existing backend actions that
// previously had no frontend caller (2026-07 audit F18); the legacy "plan"
// system is being retired in favor of this.

export const listGroups = async (workspaceID, { since } = {}) => {
    const action = {
        action: 'listGroups',
        workspaceID,
    }
    if (since != null) action.since = since
    return await mobileApiRequest(action)
}

export const getGroupStatus = async (workspaceID, groupId) => {
    const action = {
        action: 'getGroupStatus',
        workspaceID,
        groupId,
    }
    return await mobileApiRequest(action)
}

export const runGroup = async (workspaceID, configJson) => {
    const action = {
        action: 'runGroup',
        workspaceID,
        configJson: typeof configJson === 'string' ? configJson : JSON.stringify(configJson),
    }
    return await mobileApiRequest(action)
}

// Re-run a prior group with its stored config — same config, same pipeline,
// new cycle. The backend loads the config from the InvestigationGroup record.
export const rerunGroup = async (workspaceID, groupId) => {
    const action = {
        action: 'rerunGroup',
        workspaceID,
        groupId,
    }
    return await mobileApiRequest(action)
}

// A group's stored config — the basis for "view configuration" and "start a
// new run from an existing configuration".
export const getGroupConfig = async (workspaceID, groupId) => {
    const action = {
        action: 'getGroupConfig',
        workspaceID,
        groupId,
    }
    return await mobileApiRequest(action)
}
